import React, { useState } from "react";
import { Table, Select, Input, Tooltip, Popconfirm, Button } from "antd";
import { InfoCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import ModalEvaluationAnswerGroup from "../modalEvaluationAnswerGroup/modalEvaluationAnswerGroup";

const { TextArea } = Input;
const { Option } = Select;

const TableEvaluationQuestions = ({
    evlQuestions = [],
    dataEvaluationAnswerGroups = [],
    handleSelectChange,
    handleDeleteQuestion,
}) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [currentQstId, setCurrentQstId] = useState(null);

    const openModal = (qstId) => {
        setCurrentQstId(qstId);
        setModalVisible(true);
    };

    const handleCardSelect = (eagId) => {
        if (currentQstId != null && currentQstId !== undefined) {
            handleSelectChange(currentQstId, "evq_eag_id", eagId);
            setModalVisible(false);
        }
    };

    const handleInputChange = (index, field, value) => {
        handleSelectChange(index, field, value);
    };

    const columns = [
        {
            title: "Título",
            dataIndex: "evq_title",
            render: (text, record, index) => (
                <TextArea
                    value={text}
                    onChange={(e) => handleInputChange(index, "evq_title", e.target.value)}
                    autoSize={{ minRows: 1, maxRows: 3 }}
                />
            ),
        },
        {
            title: "Pregunta",
            dataIndex: "evq_question",
            render: (text, record, index) => (
                <TextArea
                    value={text}
                    onChange={(e) => handleInputChange(index, "evq_question", e.target.value)}
                    autoSize={{ minRows: 1, maxRows: 4 }}
                />
            ),
        },
        {
            title: (
                <>
                    Grupo de Respuesta{" "}
                    <Tooltip title="Haga clic en el ícono para ver más detalles">
                        <InfoCircleOutlined style={{ cursor: "pointer" }} />
                    </Tooltip>
                </>
            ),
            width: 300,
            fixed: "right",
            align: "center",
            render: (_, record, index) => (
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <Select
                        placeholder="Seleccione grupo"
                        value={record.evq_eag_id}
                        dropdownMatchSelectWidth={false}
                        style={{ minWidth: 200, width: "auto", maxWidth: 300 }}
                        onChange={(value) => handleSelectChange(index, "evq_eag_id", value)}
                    >
                        {dataEvaluationAnswerGroups.map((eag) => (
                            <Option key={eag.eag_id} value={eag.eag_id}>
                                {eag.eag_title}
                            </Option>
                        ))}
                    </Select>
                    <Tooltip title="Ver opciones de respuesta">
                        <InfoCircleOutlined
                            style={{ cursor: "pointer", color: "#1890ff" }}
                            onClick={() => openModal(index)}
                        />
                    </Tooltip>
                </div>
            ),
        },
        {
            title: "Acciones",
            key: "actions",
            align: "center",
            render: (_, __, index) => (
                <Popconfirm
                    title="¿Seguro que deseas eliminar esta pregunta?"
                    onConfirm={() => handleDeleteQuestion(index)}
                    okText="Sí"
                    cancelText="No"
                >
                    <Button danger icon={<DeleteOutlined />} />
                </Popconfirm>
            ),
        },
    ];

    return (
        <>
            <Table
                className="custom-green-table"
                size="small"
                dataSource={evlQuestions}
                columns={columns}
                rowKey={(record, index) => index}
                pagination={false}
            />

            <ModalEvaluationAnswerGroup
                visible={modalVisible}
                onClose={() => setModalVisible(false)}
                onSelect={handleCardSelect}
                dataEvaluationAnswerGroups={dataEvaluationAnswerGroups}
            />
        </>
    );
};

export default TableEvaluationQuestions;
